/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Saved_Presets_LabelInputs */

const en_preset_manager_saved_presets_label = /** @type {(inputs: Preset_Manager_Saved_Presets_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved Presets`)
};

const fr_preset_manager_saved_presets_label = /** @type {(inputs: Preset_Manager_Saved_Presets_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presets enregistres`)
};

const de_preset_manager_saved_presets_label = /** @type {(inputs: Preset_Manager_Saved_Presets_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gespeicherte Voreinstellungen`)
};

const it_preset_manager_saved_presets_label = /** @type {(inputs: Preset_Manager_Saved_Presets_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preimpostazioni salvate`)
};

const ru_preset_manager_saved_presets_label = /** @type {(inputs: Preset_Manager_Saved_Presets_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохраненные пресеты`)
};

const es_preset_manager_saved_presets_label = /** @type {(inputs: Preset_Manager_Saved_Presets_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustes preestablecidos guardados`)
};

const zh_cn2_preset_manager_saved_presets_label = /** @type {(inputs: Preset_Manager_Saved_Presets_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已保存的预设`)
};

const ja_preset_manager_saved_presets_label = /** @type {(inputs: Preset_Manager_Saved_Presets_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存されたプリセット`)
};

const hi_preset_manager_saved_presets_label = /** @type {(inputs: Preset_Manager_Saved_Presets_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सहेजे गए प्रीसेट`)
};

const pt_pt2_preset_manager_saved_presets_label = /** @type {(inputs: Preset_Manager_Saved_Presets_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Predefinições salvas`)
};

/**
* | output |
* | --- |
* | "Saved Presets" |
*
* @param {Preset_Manager_Saved_Presets_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_saved_presets_label = /** @type {((inputs?: Preset_Manager_Saved_Presets_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Saved_Presets_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_saved_presets_label(inputs)
	if (locale === "de") return de_preset_manager_saved_presets_label(inputs)
	if (locale === "it") return it_preset_manager_saved_presets_label(inputs)
	if (locale === "ru") return ru_preset_manager_saved_presets_label(inputs)
	if (locale === "es") return es_preset_manager_saved_presets_label(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_saved_presets_label(inputs)
	if (locale === "ja") return ja_preset_manager_saved_presets_label(inputs)
	if (locale === "hi") return hi_preset_manager_saved_presets_label(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_saved_presets_label(inputs)
	return en_preset_manager_saved_presets_label(inputs)
});